"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcuantResponseToJSON = exports.AcuantResponseFromJSONTyped = exports.AcuantResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function AcuantResponseFromJSON(json) {
    return AcuantResponseFromJSONTyped(json, false);
}
exports.AcuantResponseFromJSON = AcuantResponseFromJSON;
function AcuantResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'result': _1.AcuantResultEnumFromJSON(json['result']),
        'documentClass': _1.AcuantDocumentClassEnumFromJSON(json['documentClass']),
        'alerts': (json['alerts'].map(_1.AcuantAlertModelFromJSON)),
        'documentNameWithoutSeries': json['documentNameWithoutSeries'],
        'scanAttemptNumber': json['scanAttemptNumber'],
        'acuantFields': !runtime_1.exists(json, 'acuantFields') ? undefined : (json['acuantFields'].map(_1.AcuantFieldFromJSON)),
        'acuantResponseJSON': !runtime_1.exists(json, 'acuantResponseJSON') ? undefined : json['acuantResponseJSON'],
    };
}
exports.AcuantResponseFromJSONTyped = AcuantResponseFromJSONTyped;
function AcuantResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'result': _1.AcuantResultEnumToJSON(value.result),
        'documentClass': _1.AcuantDocumentClassEnumToJSON(value.documentClass),
        'alerts': (value.alerts.map(_1.AcuantAlertModelToJSON)),
        'documentNameWithoutSeries': value.documentNameWithoutSeries,
        'scanAttemptNumber': value.scanAttemptNumber,
        'acuantFields': value.acuantFields === undefined ? undefined : (value.acuantFields.map(_1.AcuantFieldToJSON)),
        'acuantResponseJSON': value.acuantResponseJSON,
    };
}
exports.AcuantResponseToJSON = AcuantResponseToJSON;
//# sourceMappingURL=AcuantResponse.js.map